@if (!application) {
<div style="display: flex;justify-content: center;align-items: center;" *ngIf="!application">
  <mat-progress-spinner mode="indeterminate" diameter="48">
  </mat-progress-spinner>
</div>
}

@if (application) {
<div class="summary-content" #printSection>
  <div class="container">
    <div class="view-application-header">
      <div class="view-application-text">
        <div class="application-number">
          <wm-common-text [data]="{text:`Application ${application.combinedApplicationNumber}`}"></wm-common-text>
        </div>

        <div class="application-status">
          @if (application.status === 1 || application.status === 0) {
          <wm-common-text [data]="{text:'InProgress'}"></wm-common-text>
          }@else if (application.status === 2) {
          <wm-common-text
            [data]="{text:`Completed on ${application.startedOn  | date: 'M/d/yyyy'} by ${submitter.userName}`}"></wm-common-text>
          }@else {
          <wm-common-text
            [data]="{text:`Submitted by ${submitter.userName} on ${application.startedOn | date: 'M/d/yyyy'}`}"></wm-common-text>
          }
        </div>

      </div>
      <div class="header-actions">
        <div class="print-icon-container" *ngIf="canViewVersion"
             title="View Application Workflow" (click)="openApplicationWorkflowBuilder()">
          <wm-common-icon [data]="{iconName:applicationWorkflowIcon}"></wm-common-icon>
        </div>
        <div class="print-icon-container">
          <wm-common-icon [data]="{iconName:printIcon}" (click)="onPrintApplicationClick()"></wm-common-icon>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      @if (submitter) {
      <div class="col">
        <h4>Applicant</h4>
        <p>{{ submitter.name }}</p>
        <p>
          <a class="janus-link" href="tel:{{ submitter.phoneNumber }}">{{ submitter.phoneNumber }}</a>
        </p>
        <p>
          <a class="janus-link" href="mailto:{{ submitter.emailAddress }}">{{ submitter.emailAddress }}</a>
        </p>
      </div>
      }
    </div>


    <div class="row mt-3">
      <div class="col">
        @if(isPrintApplication === true){
        <wm-application-print-summary [activities]="summaryActivities" [applicationId]="application.id"
          [application]="application"></wm-application-print-summary>
        }@else {
        <wm-application-readonly [applicationId]="application.id" [application]="application"
          [activities]="summaryActivities" [editApplicationJanusView]="true" [appStatusCode]="applicationStatus">
        </wm-application-readonly>
        }

      </div>
    </div>
  </div>
</div>
}
